import { useState } from "react";

export const useBulkActions = () => {
  const [selectedTasks, setSelectedTasks] = useState([]);

  const toggleSelect = (taskId) => {
    setSelectedTasks((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId]
    );
  };

  const clearSelection = () => setSelectedTasks([]);

  return { selectedTasks, toggleSelect, clearSelection };
};
